export default __webpack_public_path__ + "static/media/yamblu.36c30f0d.webp";